import service from '@/utils/request'; // CreateStationOilEngineInfo 创建油机基础信息
// @Tags Station
// @Summary 创建油机基础信息
// @Security ApiKeyAuth
// @accept application/json
// @Produce application/json
// @Param data body bairunModel.StationOilEngineModel true "创建油机基础信息"
// @Success 200 {string} string "{"success":true,"data":{},"msg":"获取成功"}"
// @Router /stationManage/oilEngineInfo/create [post]

export var createStationOilEngineInfo = function createStationOilEngineInfo(data) {
  return service({
    url: '/stationManage/oilEngineInfo/create',
    method: 'post',
    data: data
  });
}; // DeleteStationOilEngineInfo 删除油机信息
// @Tags Station
// @Summary 删除油机信息
// @Security ApiKeyAuth
// @accept application/json
// @Produce application/json
// @Param data body bairunModel.StationOilEngineInfo true "删除油机信息"
// @Success 200 {string} string "{"success":true,"data":{},"msg":"删除成功"}"
// @Router /stationManage/oilEngineInfo/delete [delete]

export var deleteStationOilEngineInfo = function deleteStationOilEngineInfo(data) {
  return service({
    url: '/stationManage/oilEngineInfo/delete',
    method: 'post',
    data: data
  });
}; // DeleteStationOilEngineInfoByIds 批量删除油机信息
// @Tags Station
// @Summary 批量删除油机信息
// @Security ApiKeyAuth
// @accept application/json
// @Produce application/json
// @Param data body request.IdsReq true "批量删除油机信息"
// @Success 200 {string} string "{"success":true,"data":{},"msg":"批量删除成功"}"
// @Router /stationManage/oilEngineInfo/deleteByIds [delete]

export var deleteStationOilEngineInfoByIds = function deleteStationOilEngineInfoByIds(data) {
  return service({
    url: '/stationManage/oilEngineInfo/deleteByIds',
    method: 'post',
    data: data
  });
}; // UpdateStationOilEngineInfo 更新油机基础信息
// @Tags Station
// @Summary 更新油机基础信息
// @Security ApiKeyAuth
// @accept application/json
// @Produce application/json
// @Param data body bairunModel.StationOilEngineModel true "更新油机基础信息"
// @Success 200 {string} string "{"success":true,"data":{},"msg":"更新成功"}"
// @Router /stationManage/oilEngineInfo/update [put]

export var updateStationOilEngineInfo = function updateStationOilEngineInfo(data) {
  return service({
    url: '/stationManage/oilEngineInfo/update',
    method: 'put',
    data: data
  });
}; // FindStationOilEngineInfo 根据id查询油机基础信息
// @Tags Station
// @Summary 根据id查询油机基础信息
// @Security ApiKeyAuth
// @accept application/json
// @Produce application/json
// @Param data body bairunModel.StationOilEngineModel true "根据id查询油机基础信息"
// @Success 200 {string} string "{"success":true,"data":{},"msg":"查询成功"}"
// @Router /stationManage/oilEngineInfo/find [get]

export var findStationOilEngineInfo = function findStationOilEngineInfo(params) {
  return service({
    url: '/stationManage/oilEngineInfo/find',
    method: 'get',
    params: params
  });
}; // GetStationOilEngineInfoList 分页获取油机列表信息
// @Tags Station
// @Summary 分页获取油机列表信息
// @Security ApiKeyAuth
// @accept application/json
// @Produce application/json
// @Param data body bairunRequest.StationOilEngineInfoSearch true "分页获取油机列表信息"
// @Success 200 {string} string "{"success":true,"data":{},"msg":"获取成功"}"
// @Router /stationManage/oilEngineInfo/getList [get]

export var getStationOilEngineInfoList = function getStationOilEngineInfoList(params) {
  return service({
    url: '/stationManage/oilEngineInfo/getList',
    method: 'get',
    params: params
  });
};